import { QRCODE_STATIC_STEP } from './qr-code';

export const PATH = {
  API: '/app/api',
  CONFIRMATION: '/confirmation/magic_link_confirm',
  QR: {
    CREATE: '/app/create_qr',
    CREATE_STATIC: '/app/create_qr_static',
    CREATE_QR_STATIC_CONTENT: (type = ':type') => `${PATH.QR.CREATE_STATIC}/${QRCODE_STATIC_STEP.CONTENT}/${type}`,
    EDIT_QR_STATIC: (step = ':step', type = ':type', id = ':id') => `/app/edit_qr_static/${step}/${type}/${id}`,
    LIMIT_REACHED: '/qr/limit-reached',
    NOT_FOUND: '/qr/not-found',
    DEACTIVATED: '/app/qr/deactivated',
    MAIN: '/app/my_qr',
    DETAIL: '/app/my_qr/detail',
    FOLDER: '/app/my_qr/folders/:folderId/:folderName',
  },
  LOGIN: '/login',
  SIGN_UP: '/sign_up',
  FACEBOOK_LOGIN: '/facebook-login',
  PAYMENTS: {
    MAIN: '/app/payments',
    CHECKOUT: '/app/payments/checkout',
    SUCCESS: '/app/payments/sucess',
    CANCEL_SUBSCRIPTION: '/app/cancel-subscription',
  },
  SETTINGS: '/app/settings',
  ANALYTICS: '/app/analytics',
  S: (id = ':id') => `/s/${id}`,
  TOS: '/tos',
  UNAUTH: {
    MAIN: '/',
    PRICES_AND_PLANS: '/plans-and-prices',
    FAQ: '/faq',
    PRIVACY_POLICY: '/privacy-policy',
    DATA_DELETION: '/data-deletion',
    QRS_ON: '/qrs-on',
    QRS_ON_DETAIL: (on = ':on') => `/qrs-on/${on}`,
    CONTACT_US: '/contact-us',
  },
};
